import {
  ConnectionTypeEnum,
  PollingDeviceEnum,
  InstallationStateEnum,
  ConnectionStateEnum,
  SIMEnum,
} from '@core/models';

export const DEVICE_DETAIL_TABS = [
  { index: 0, title: 'devices.detailTabs.general.label',        route: 'general' },
  { index: 1, title: 'devices.detailTabs.insights.label',       route: 'insights' },
  { index: 2, title: 'devices.detailTabs.configuration.label',  route: 'configuration' },
  { index: 3, title: 'devices.detailTabs.activity.label',       route: 'activity' },
  { index: 4, title: 'devices.detailTabs.alarms.label',         route: 'alarms' },
  { index: 5, title: 'devices.detailTabs.deviceSettings.label', route: 'alarm-settings' },
];

// Appended after the tabs every user has, so adding it for some users moves none of theirs: the
// tab bar selects by index.
export const DEVICE_FEEDS_TAB = {
  index: 6,
  title: 'devices.detailTabs.feeds.label',
  route: 'feeds',
};

export const SIM = [
  {
    index: SIMEnum.Online,
    label: 'devices.filter.SIM.online',
  },
  {
    index: SIMEnum.Offline,
    label: 'devices.filter.SIM.offline',
  },
];

/** Online/offline device status shown on the devices list — derived from the backend's
 * consolidated `deviceOnlineStatus` field (RDT-722), not the device's own SIM status. Replaces
 * the devices-page's old `simStatus`/`pollingStatus` filters with one simplified status a
 * dashboard drill-through can link to directly. Named distinctly from location.constant.ts's
 * own `DEVICE_STATUS` (a different, installation-status concept). */
export const DEVICE_CONNECTIVITY_STATUS = [
  {
    index: 'Online',
    label: 'devices.filter.status.online',
  },
  {
    index: 'Offline',
    label: 'devices.filter.status.offline',
  },
];

/** The installation dimension of the device status (RDT-1565): options of the devices list's
 * installation filter and the dashboard's installation donut. */
export const INSTALLATION_STATES: string[] = Object.values(InstallationStateEnum);

export const INSTALLATION_STATE_LABEL_KEYS: Record<InstallationStateEnum, string> = {
  [InstallationStateEnum.Installed]: 'home.devicesWidget.installed',
  [InstallationStateEnum.ToBeInstalled]: 'home.devicesWidget.toBeInstalled',
  [InstallationStateEnum.InstallationFailed]: 'home.devicesWidget.installationFailed',
};

export const CONNECTION_STATE_LABEL_KEYS: Record<ConnectionStateEnum, string> = {
  [ConnectionStateEnum.Online]: 'home.devicesWidget.online',
  [ConnectionStateEnum.Offline]: 'home.devicesWidget.offline',
};

export const POLLING = [
  {
    index: PollingDeviceEnum.NeverReceived,
    label: 'devices.filter.polling.neverReceived',
  },
  {
    index: PollingDeviceEnum.ReceivedAsExpected,
    label: 'devices.filter.polling.receivedAsExpected',
  },
  {
    index: PollingDeviceEnum.PollingOverdue,
    label: 'devices.filter.polling.pollingOverdue',
  },
];

export const CONNECTION_TYPES = [
  {
    index: ConnectionTypeEnum.SIMConnection,
    label: 'devices.filter.connectionType.SIMConnection',
  },
  {
    index: ConnectionTypeEnum.LANConnection,
    label: 'devices.filter.connectionType.LANConnection',
  },
  {
    index: ConnectionTypeEnum.SIMAndLAN,
    label: 'devices.filter.connectionType.SIMAndLAN',
  },
  {
    index: ConnectionTypeEnum.NoConnection,
    label: 'devices.filter.connectionType.noConnection',
  },
];
